import React from 'react';

import Hero from "../components/home/Hero";
import PowerFull from "../components/home/Powerfull";
import CallUs from "../components/home/CallUs";
import Services from "../components/home/Services";
import FlexManagement from "../components/home/FlexManagment";

const Home = () => {
  return (
    <div>
      {/* 1. Hero — Bold above-the-fold impression */}
      <Hero />

      {/* 2. Core feature cards — what the platform does */}
      <PowerFull />

      {/* 5. Scroll-driven feature deep-dives */}
      <Services />

      {/* 6. Why FMS — differentiation */}
      <FlexManagement />

      {/* 7. Final CTAs — conversion */}
      <CallUs />
    </div>
  );
};

export default Home;
